export default __webpack_public_path__ + "static/image 66-5e138b78de15eb853562e83dc8dd982a.png";